export default __webpack_public_path__ + "static/media/transpaleta7.2.22ac202d.jpg";